import { Alert, Snackbar } from "@mui/material";
import React from "react";

function NonValidEmailSnackbar({emailAddedToListError, handleCloseEmailAddedToListError, emailForUpdates}) {
    return (<Snackbar anchorOrigin={{
  vertical: 'bottom',
  horizontal: 'center'
  }} open={emailAddedToListError} autoHideDuration={4000} onClose={handleCloseEmailAddedToListError}>
    <Alert variant="filled" onClose={handleCloseEmailAddedToListError} severity="error" sx={{
  width: '100%'
  }}>
      Email "{emailForUpdates}" is not valid. Please correct and send again 🙃
    </Alert>
  </Snackbar>);
  }

export default NonValidEmailSnackbar;